export default "__VITE_ASSET__CPknONB6__"